module.exports = __webpack_public_path__ + "img/minus.0c775e20.svg";